import { WEB_COMPONENT_SENSOR_GCP } from '../../../webcomponents.constants';
import { GCPSensorComponent } from './component/GCPSensorComponent';

export { GCPSensorComponent };
window.customElements.define(WEB_COMPONENT_SENSOR_GCP, GCPSensorComponent);
